.chip {
    display: inline-block;
    padding: 8px 16px;
    font-size: 14px;
    color: white;
    background-color: rgb(139, 195, 74);
    border-radius: 4px;
  }
  